import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || '';
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;

        if (!sessionId) {
            setError('Missing session_id in callback URL.');
            return;
        }

        (async () => {
            try {
                await api.post('/auth/google/session', { session_id: sessionId });
                // Clear hash, refresh auth context, redirect.
                window.history.replaceState(
                    null,
                    '',
                    window.location.pathname
                );
                await refresh();
                navigate('/account', { replace: true });
            } catch (e) {
                setError(
                    e.response?.data?.detail ||
                        'Google sign-in failed. Please try again.'
                );
                setTimeout(() => navigate('/login', { replace: true }), 2200);
            }
        })();
    }, [navigate, refresh]);

    return (
        <main className="mx-auto max-w-md px-5 sm:px-8 pt-24 pb-32 text-center">
            <div className="uppercase-mono text-muted-foreground animate-soft-pulse">
                {error ? error : 'Finalizing sign in…'}
            </div>
        </main>
    );
}
